var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46951 30.9822C1.15277 30.485 1.4244 29.677 1.92191 29.677H3.36932L3.369 21.4123C3.369 20.9771 3.5952 20.6667 3.91162 20.6667H5.58493C5.90166 20.6667 6.12755 20.9775 6.12755 21.4123L6.12786 29.677H7.57527C8.07278 29.677 8.34409 30.4226 8.02767 30.9822L5.2237 35.8292C4.99751 36.202 4.54543 36.202 4.31925 35.8292L1.46951 30.9822Z",
    fill: "#718096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6941 30.9822C39.0108 30.485 38.7392 29.677 38.2417 29.677H36.7943L36.7946 21.4123C36.7946 20.9771 36.5684 20.6667 36.252 20.6667H34.5787C34.2619 20.6667 34.036 20.9775 34.036 21.4123L34.0357 29.677H32.5883C32.0908 29.677 31.8195 30.4226 32.1359 30.9822L34.9399 35.8292C35.1661 36.202 35.6181 36.202 35.8443 35.8292L38.6941 30.9822Z",
    fill: "#718096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93698 14.0227H29.4917C29.7586 14.0227 29.975 13.8063 29.975 13.5394V12.0391C29.975 11.8804 29.8978 11.7336 29.7701 11.6446L19.9909 4.7538C19.8247 4.63773 19.6004 4.63773 19.4341 4.7538L9.65852 11.6446C9.53087 11.7336 9.45361 11.8844 9.45361 12.0391V13.5394C9.45344 13.8061 9.67009 14.0226 9.93692 14.0226L9.93698 14.0227ZM19.7125 7.96325C20.6831 7.96325 21.468 8.74817 21.468 9.71875C21.468 10.6893 20.6831 11.4743 19.7125 11.4743C18.742 11.4743 17.957 10.6893 17.957 9.71875C17.9569 8.74835 18.742 7.96325 19.7125 7.96325Z",
    fill: "#718096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7295 24.4553V25.2672H15.6638V24.4553C15.6638 24.2929 15.5285 24.1575 15.3659 24.1575L11.0275 24.1576C10.8613 24.1614 10.7297 24.2929 10.7297 24.4553L10.7295 24.4553Z",
    fill: "#718096"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6638 14.7844H10.7295V15.5964C10.7295 15.7587 10.8648 15.8942 11.0273 15.8942H15.3659C15.5283 15.8942 15.6637 15.7589 15.6637 15.5964L15.6638 14.7844Z",
    fill: "#718096"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2412 24.4556V25.2676L22.1832 25.2677V24.4558C22.1832 24.2934 22.0479 24.158 21.8854 24.158H17.5429C17.3766 24.1617 17.2412 24.2933 17.2412 24.4556Z",
    fill: "#718096"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5151 24.4556V25.2676L28.4572 25.2677V24.4558C28.4572 24.2934 28.3219 24.158 28.1593 24.158H23.8168C23.6506 24.1617 23.5151 24.2933 23.5151 24.4556Z",
    fill: "#718096"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1832 14.7844H17.2412V15.5964C17.2412 15.7587 17.3765 15.8942 17.5428 15.8942H21.8814C22.0437 15.8942 22.1792 15.7589 22.1792 15.5964V14.7844H22.1832Z",
    fill: "#718096"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.695 15.5965V14.7846L23.7607 14.7844V15.5964C23.7607 15.7587 23.896 15.8942 24.0586 15.8942H28.3971C28.5634 15.8942 28.6948 15.7628 28.6948 15.5965L28.695 15.5965Z",
    fill: "#718096"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5688 16.656H14.8247V23.3959H11.5688V16.656Z",
    fill: "#718096"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.084 16.656H21.3398V23.3959H18.084V16.656Z",
    fill: "#718096"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0608 26.0332H9.90586C9.5888 26.0332 9.3335 26.2885 9.3335 26.6056V28.0943C9.3335 28.4114 9.58878 28.6667 9.90586 28.6667H30.0608C30.6062 28.1213 30.6062 26.4849 30.0608 26.0332Z",
    fill: "#718096"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8559 23.2121V16.6558H24.6001V23.2121C27.8559 23.2121 24.6001 23.2121 27.8559 23.2121Z",
    fill: "#718096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankExpense);
export default __webpack_public_path__ + "static/media/BankExpense.a82ae84f6cc78c302a375205bbf86371.svg";
export { ForwardRef as ReactComponent };